import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiGit,
  DiFirebase,
} from "react-icons/di";
import {
  SiTailwindcss,
  SiChakraui,
  SiMaterialdesign,
  SiStyledcomponents,
  SiSocketdotio,
  SiTypescript,
  SiNextdotjs,
  SiNestjs,
  SiRedis,
  SiSolidity,
  SiPostgresql,
  SiVuedotjs,
  SiAngularjs,
  SiRabbitmq,
  SiStrapi,
} from "react-icons/si";
import { TbBrandReactNative } from "react-icons/tb";
import { WalletConnect, MetaMask, Coinbase, Solana } from "react-web3-icons"

function TechnicalStack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center gap"
      >
        <DiJavascript1 />
        <span className="text-12">JavaScript</span>
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiTypescript />
        <span className="text-12">Typescript</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <DiReact />
        <span className="text-12">ReactJS</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <TbBrandReactNative/>
        <span className="text-12">React Native</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiNextdotjs />
        <span className="text-12">NextJS</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiVuedotjs />
        <span className="text-12">VueJS</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiAngularjs />
        <span className="text-12">AngularJS</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiTailwindcss />
        <span className="text-12">TailwindCSS</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiChakraui />
        <span className="text-12">Charka UI</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiMaterialdesign />
        <span className="text-12">Material UI</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiStyledcomponents />
        <span className="text-12">Styled Component</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiSocketdotio />
        <span className="text-12">SocketIO</span>

      </Col>

      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <DiNodejs />
        <span className="text-12">NodeJS</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiNestjs />
        <span className="text-12">NestJS</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiSolidity />
        <span className="text-12">Solidity</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <DiMongodb />
        <span className="text-12">MongoDB</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <DiGit />
        <span className="text-12">Git</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <DiFirebase />
        <span className="text-12">Firebase</span>
        
      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiRedis />
        <span className="text-12">Redis</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiPostgresql />
        <span className="text-12">PostgreSQL</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiRabbitmq />
        <span className="text-12">RabbitMQ</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <SiStrapi />
        <span className="text-12">Strapi</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <MetaMask />
        <span className="text-12">Metamask</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <WalletConnect />
        <span className="text-12">Wallet Connect</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <Coinbase />
        <span className="text-12">Coinbase</span>

      </Col>
      <Col
        xs={4}
        md={2}
        className="tech-icons d-flex flex-column justify-content-center align-items-center"
      >
        <Solana />
        <span className="text-12">Solana</span>

      </Col>
      
    </Row>
  );
}

export default TechnicalStack;
